// Repo-index default query for the search bar / `q` param. No sort qualifier
// (the default sort is applied server-side). Not the dashboard's `assignee:@me`.
export const REPO_INDEX_DEFAULT_QUERY = 'is:issue state:open'

/**
 * Resolves the search query: the explicit `q` param, else the repo default.
 */
export function issuesIndexQueryResolver({searchParams}: {searchParams: URLSearchParams}): string {
  const q = searchParams.get('q')
  if (q) return q
  return REPO_INDEX_DEFAULT_QUERY
}
